import styled from 'styled-components';

export const Image = styled.img<{ hasFilter: boolean }>`
  border-radius: 50%;
  filter: ${({ hasFilter }) => (hasFilter ? 'grayscale(100%)' : 'none')};
  height: 100%;
  object-fit: cover;
  width: 100%;
`;
